<template>
  <v-container tag="section" class="content detail">
    <v-row justify="center">
      <v-form @submit.prevent="onSave()">
        <v-slide-y-transition appear>
          <base-material-card
            color="warning"
            light
            max-width="100%"
            :width="$vuetify.breakpoint.mdAndUp ? '800' : '100%'"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  {{ $t("privacy_page.title") }}
                </h1>
                <p>{{ $auth.user().name }}</p>
              </div>
            </template>

            <v-card-text class="text-left">
              <p>{{ $t("privacy_page.subtitle") }}</p>

              <v-spacer />
              <h4 class="mt-5 pt-5">{{ $t("register.privacy_data") }}</h4>
              <a
                style="padding-top: 5px;display: block;"
                :href="$store.state.modules.options.app_privacy"
                target="_blank"
                >{{ $t("register.privacy.accept_agb_show") }}</a
              >

              <v-checkbox
                style="margin-top: 0px;"
                v-model="model.privacy_agb"
                name="privacy_agb"
                data-vv-name="privacy_agb"
                :error-messages="errors.collect('privacy_agb')"
                :label="$t('register.privacy.accept_agb')"
              >
              </v-checkbox>

              <template
                v-if="$store.state.modules.options.photo_privacy == '1'"
              >
                <v-spacer />

                <h4 class="mt-5 mt-5">
                  {{ $t("register.privacy.photo_title") }}
                </h4>

                <v-checkbox
                  v-model="model.privacy_photo"
                  :label="$t('register.privacy.photo_yes')"
                  :value="'yes'"
                  name="privacy_photo_yes"
                  data-vv-name="privacy_photo_yes"
                  :error-messages="errors.collect('privacy_photo')"
                ></v-checkbox>
                
                <v-checkbox
                  class="mt-0"
                  v-model="model.privacy_photo"
                  :label="$t('register.privacy.photo_no')"
                  :value="'no'"
                  name="privacy_photo_no"
                  data-vv-name="privacy_photo_no"
                  :error-messages="errors.collect('privacy_photo')"
                ></v-checkbox>
                <br><br>
              </template>

              <p>{{ $t("register.privacy.sign_here") }}</p>

              <VueSignaturePad
                width="100%"
                height="200px"
                :customStyle="{ border: 'black 2px solid' }"
                ref="signaturePad"
              />
              <a
                href="#"
                style="font-size: 12px;float:right"
                @click.prevent="$refs.signaturePad.undoSignature()"
              >
                {{ $t("register.privacy.sign_delete") }}</a
              >

              <div style="clear: both;margin-bottom: 30px;"></div>

              <div class="text-center mt-5">
                <pages-btn
                  large
                  color="success"
                  depressed
                  class="v-btn--text"
                  type="submit"
                >
                  {{ $t("privacy_page.button_submit") }}
                </pages-btn>
              </div>
            </v-card-text>
            <a @click="$router.go(-1)">
              {{ $t("back_to_prev_page") }}
            </a>
            <br />
            <br />
            <br />
          </base-material-card>
        </v-slide-y-transition>
      </v-form>
    </v-row>
  </v-container>
</template>

<script>
import { updateUser } from "./shared/services";
import Swal from "sweetalert2";

export default {
  name: "forgot",
  $_veeValidate: {
    validator: "new"
  },
  components: {
    PagesBtn: () =>
      import("@/app/shared/components/template/pages/components/Btn")
  },
  data() {
    return {
      model: {
        privacy_agb: false,
        privacy_photo: null
      }
    };
  },
  mounted() {
    if (
      !this.$auth.user().id ||
      !this.$auth.user().people.privacy_verification_needed
    ) {
      this.$router.push({ name: "frontend.index" });
    }
  },
  methods: {
    onSave() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        Swal.fire({
          icon: "error",
          title: this.$t("Fehler"),
          text: this.$t("error_missing_signature")
        });
        return;
      }

      updateUser({ ...this.model, signature: data }, this.$validator)
        .then(resp => {
          this.$auth.fetch();
          this.$root.$notification(this.$t("privacy_page.success_message"), {
            type: "success"
          });
          this.$router.go(-1);
        })
        .catch(resp => {
          // this.$root.$notification(resp.message, { color: "error" });
        });
    }
  }
};
</script>

<style lang="scss">
.v-select .v-select__selections {
  text-transform: none !important;
}
</style>
